import types from './actionTypes';

export const resetState = () => ({
  type: types.RESET_INVOICES_STATE,
});

export const fetchInvoicesByUser = (userId) => ({
  type: types.FETCH_INVOICES_BY_USER.REQUEST,
  userId,
});

export const fetchInvoicesByUserSuccess = (invoices) => ({
  type: types.FETCH_INVOICES_BY_USER.SUCCESS,
  invoices,
});

export const fetchInvoicesByUserFailure = (error) => ({
  type: types.FETCH_INVOICES_BY_USER.FAILURE,
  error,
});
